import ActionType from '../actions/ActionType'

export default (
	state = {
		deleteDialogOpen: false,
		entityType: null,
		entitySubtype: null,
		name: null,
		id: null,
		entity: undefined,
		// deleteErrors: null,
		// deleteErrorsEntity: null,
	},
	action,
) => {
	switch (action.type) {
		case ActionType.View.TOGGLE_DELETE_DIALOG:
			return {
				...state,
				id: Boolean(action.payload) ? action.payload.id : null,
				entityType: Boolean(action.payload) ? action.payload.entityType : null,
				name: Boolean(action.payload) ? action.payload.name : null,
				entitySubtype: Boolean(action.payload)
					? action.payload.entitySubtype
					: null,
				deleteDialogOpen: Boolean(action.payload),
				entity: Boolean(action.payload) ? action.payload.entity : undefined,
			}
		// case ActionType.Data.DELETE_FAILURE:
		//   if (action.payload) {
		//     return {
		//       ...state,
		//       deleteErrors: action.payload,
		//       deleteErrorsEntity: action.entityType,
		//     }
		//   }
		//   return state
		// case ActionType.View.TOGGLE_DELETE_ERRORS_DIALOG:
		//   return {
		//     ...state,
		//     deleteErrors: null,
		//     deleteErrorsEntity: null,
		//   }
		default:
			return state
	}
}
